export const innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
    <path fill="currentcolor" d="M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2Zm0 1.5a8.5 8.5 0 1 0 0 17 8.5 8.5 0 0 0 0-17Zm.076 6.042a.9.9 0 0 1 .809.896v6.318h1.474a.9.9 0 0 1 0 1.8H10a.9.9 0 0 1 0-1.8h1.084v-5.418h-.615a.9.9 0 0 1 0-1.8h1.515l.092.004ZM11.5 5.438a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Z"/>
</svg>
`;
